import React, {Component} from "react";
import {
  Panel,
  Modal,
  Button
}                         from "react-bootstrap";
import moment             from "moment";
import {
  ToastContainer,
  toast
}                         from "react-toastify";
import                         "react-toastify/dist/ReactToastify.css";
import axios              from "axios";

import {
  IS_VALID,
  IS_EMPTY_STRING,
  IS_UNDEFINED,
  IS_LENGTH_ZERO
}                         from "utils";

import CrudComponent      from "./../zynappse-crud";
import
CampaignCategorySchema    from "./CampaignCategorySchema";
import FormContainer      from "./FormContainer";

const WEB_PATH = window.__APP_CONFIG__.webPath || 'http://localhost:3000';

class CampaignCategory extends Component {
  constructor (props) {
    super(props);

    this.refreshTableReference;

    this.saveData= this.saveData.bind(this);
    this.deleteData = this.deleteData.bind(this);
    this.refreshTable = this.refreshTable.bind(this);
    this.loadOptions = this.loadOptions.bind(this);
    this.renderModalButton = this.renderModalButton.bind(this);
  }
  
  saveData (isDraft = false) {
    let {
      CampaignCategory,
      actions
    } = this.props;

    let {
      selectedData,
      formType,
      formTitle,
      formId,

      image,
      bannerImage,
      title,
      descriptions,
      earningPeriod,
      earningPeriodStartDate,
      earningPeriodEndDate,
      campaignStartDate,
      campaignEndDate,
      evoucherSortColumn,
      evoucherSorting,

      availabilityStartTime,
      availabilityEndTime
    } = CampaignCategory;

    let isDateRange = IS_VALID(earningPeriod) && earningPeriod.label.toUpperCase() === "DATE RANGE",
        isDaily = IS_VALID(earningPeriod) && earningPeriod.label.toUpperCase() === "DAILY";

    let isEVoucherPublished = (
      IS_VALID(selectedData) &&
      IS_VALID(selectedData.get("status")) &&
      (
        selectedData.get("status") === "PUBLISH" ||
        selectedData.get("status") === "EXPIRED"
      ) &&
      (
        IS_VALID(selectedData.get("campaignStartDate")) &&
        moment(selectedData.get("campaignStartDate")).isSameOrBefore(moment())
      )
    );

    let getAvailabilityTime = () => {
      let month = moment().month(),
          date = moment().date(),
          year = moment().year();

      // if (!IS_VALID(availabilityStartTime)) {
      //   return "Availability Start Time is required.";
      // } else
      if (
        IS_VALID(availabilityStartTime) &&
        !moment(availabilityStartTime, "hh:mm A", true).isValid()
      ) {
        return "Please select a valid Availability Start Time.";
      } else
      // if (!IS_VALID(availabilityEndTime)) {
      //   return "Availability End Time is required.";
      // } else
      if (
        IS_VALID(availabilityEndTime) &&
        !moment(availabilityEndTime, "hh:mm A", true).isValid()
      ) {
        return "Please select a valid Availability End Time.";
      } else if (
        moment(availabilityEndTime, "hh:mm A", true).month(month).date(date).year(year).isBefore(moment(availabilityStartTime, "hh:mm A", true).month(month).date(date).year(year))
      ) {
        return "Availability End Time should be greater Availability Start Time";
      } else if (
        moment(availabilityEndTime, "hh:mm A", true).month(month).date(date).year(year).isSame(moment(availabilityStartTime, "hh:mm A", true).month(month).date(date).year(year))
      ) {
        return "Availability Start Time and Availability End Time should not be the same.";
      } else if (
        moment(availabilityStartTime, "hh:mm A", true).month(month).date(date).year(year).isBetween(moment("12:00 AM", "hh:mm A", true).month(month).date(date).year(year).subtract(1, "minutes"), moment("03:59 AM", "hh:mm A", true).month(month).date(date).year(year)) ||
        moment(availabilityEndTime, "hh:mm A", true).month(month).date(date).year(year).isBetween(moment("12:00 AM", "hh:mm A", true).month(month).date(date).year(year).subtract(1, "minutes"), moment("03:59 AM", "hh:mm A", true).month(month).date(date).year(year))
      ) {
        return "Availability Time should not start/end between 12: 00 AM and 03:59 AM";
      }

      return false;
    };

    let getAvailabilityTimeResult = getAvailabilityTime();
    
    if (
      !isDraft &&
      (
        !IS_VALID(title) ||
        !IS_VALID(title.trim())
      )
    ) {
      toast.error("Title is required.");
    } else if (
      !isDraft &&
      (
        !IS_VALID(descriptions) ||
      !IS_VALID(descriptions.trim())
      )
    ) {
      toast.error("Description is required.");
    } else if (
      !isDraft &&
      !IS_VALID(earningPeriod)
    ) {
      toast.error("Earning Period is required.");
    } else if (
      !isDraft &&
      isDateRange &&
      !IS_VALID(earningPeriodStartDate)
    ) {
      toast.error("Earning Period Start Date is required.");
    } else if (
      !isDraft &&
      isDateRange &&
      !moment(earningPeriodStartDate, "MMM DD, YYYY", true).isValid()
    ) {
      toast.error("Please select a valid Earning Period Start Date.");
    } else if (
      !isDraft &&
      isDateRange &&
      !IS_VALID(earningPeriodEndDate)
    ) {
      toast.error("Earning Period End Date is required.");
    } else if (
      !isDraft &&
      isDateRange &&
      !moment(earningPeriodEndDate, "MMM DD, YYYY", true).isValid()
    ) {
      toast.error("Please select a valid Earning Period End Date.");
    } else if (
      !isDraft &&
      isDaily &&
      getAvailabilityTimeResult
    ) {
      toast.error(getAvailabilityTimeResult);
    } else if (
      !isDraft &&
      !IS_VALID(campaignStartDate)
    ) {
      toast.error("Campaign Start Date is required.");
    } else if (
      !isDraft &&
      !moment(campaignStartDate, "MMM DD, YYYY hh:mm A", true).isValid()
    ) {
      toast.error("Please select a valid Campaign Start Date");
    } else if (
      !isDraft &&
      !isEVoucherPublished &&
      IS_VALID(campaignStartDate) &&
      moment(campaignStartDate, "MMM DD, YYYY hh:mm A", true).isBefore(moment(), "day")
    ) {
      toast.error("Campaign Start Date should be greater than or equal to the date today.");
    } else if (
      !isDraft &&
      !IS_VALID(campaignEndDate)
    ) {
      toast.error("Campaign End Date is required.");
    } else if (
      !isDraft &&
      !moment(campaignEndDate, "MMM DD, YYYY hh:mm A", true).isValid()
    ) {
      toast.error("Please select a valid Campaign End Date");
    } else if (
      !isDraft &&
      moment(campaignEndDate, "MMM DD, YYYY hh:mm A", true).isSameOrBefore(moment())
    ) {
      toast.error("Campaign End Date should be greater than the date today.");
    } else if (
      !isDraft &&
      IS_VALID(campaignStartDate) &&
      IS_VALID(campaignEndDate) &&
      moment(campaignEndDate, "MMM DD, YYYY hh:mm A", true).isBefore(moment(campaignStartDate, "MMM DD, YYYY hh:mm A", true))
    ) {
      toast.error("Campaign End Date should be greater than Campaign Start Date.");
    } else if (
      !isDraft &&
      IS_VALID(campaignStartDate) &&
      IS_VALID(campaignEndDate) &&
      moment(campaignEndDate, "MMM DD, YYYY hh:mm A", true).isSame(moment(campaignStartDate, "MMM DD, YYYY hh:mm A", true))
    ) {
      toast.error("Campaign Start Date and Campaign End Date should not be the same.");
    } else if (
      !isDraft &&
      isDateRange &&
      IS_VALID(earningPeriodStartDate) &&
      IS_VALID(campaignStartDate) &&
      moment(earningPeriodStartDate, "MMM DD, YYYY", true).isBefore(moment(campaignStartDate, "MMM DD, YYYY hh:mm A", true), "day")
    ) {
      toast.error("Earning Period Start Date should be greater than or equal to Campaign Start Date.");
    } else if (
      !isDraft &&
      isDateRange &&
      IS_VALID(earningPeriodEndDate) &&
      IS_VALID(campaignEndDate) &&
      moment(earningPeriodEndDate, "MMM DD, YYYY", true).isAfter(moment(campaignEndDate, "MMM DD, YYYY hh:mm A", true), "day")
    ) {
      toast.error("Earning Period End Date should be less than or equal to Campaign End Date.");
    } else if (
      !IS_VALID(evoucherSortColumn)
    ) {
      toast.error("EVoucher Sorting is required.");
    } else if (
      !IS_VALID(evoucherSorting)
    ) {
      toast.error("EVoucher Sorting is required.");
    } else {
      let fd = new FormData();

      let dataToAppend = {
        userId: Parse.User.current().id,
        status: isDraft ? "DRAFT" : "PUBLISH",
        evoucherSortColumn: evoucherSortColumn.value,
        evoucherSorting: evoucherSorting.value
      };

      if (IS_VALID(title)) {
        dataToAppend.title = title;
      }

      if (IS_VALID(descriptions)) {
        dataToAppend.descriptions = descriptions;
      }

      if (
        IS_VALID(earningPeriod) &&
        IS_VALID(earningPeriod.value)
      ) {
        dataToAppend.earningPeriodId = earningPeriod.value;

        if (isDateRange) {
          if (IS_VALID(earningPeriodStartDate)) {
            dataToAppend.earningPeriodStartDate = moment(earningPeriodStartDate, "MMM DD, YYYY", true).hour(4).minute(0).format(); // startOf("d")
          }
    
          if (IS_VALID(earningPeriodEndDate)) {
            dataToAppend.earningPeriodEndDate = moment(earningPeriodEndDate, "MMM DD, YYYY", true).endOf("d").format(); // hour(3).minute(59).second(59)
          }
        }

        if (
          isDaily &&
          IS_VALID(availabilityStartTime) &&
          moment(availabilityStartTime, "hh:mm A", true).isValid() &&
          IS_VALID(availabilityEndTime) &&
          moment(availabilityStartTime, "hh:mm A", true).isValid()
        ) {
          let month = moment().month(),
              date = moment().date(),
              year = moment().year();

          dataToAppend.availabilityStartTime = moment(availabilityStartTime, "hh:mm A", true).month(month).date(date).year(year).format();
    
          dataToAppend.availabilityStartTime_string = moment(availabilityStartTime, "hh:mm A", true).month(month).date(date).year(year).format("hh:mm A");

          dataToAppend.availabilityEndTime = moment(availabilityEndTime, "hh:mm A", true).month(month).date(date).year(year).format();
    
          dataToAppend.availabilityEndTime_string = moment(availabilityEndTime, "hh:mm A", true).month(month).date(date).year(year).format("hh:mm A");
        }
      }

      if (campaignStartDate) {
        dataToAppend.campaignStartDate = moment(campaignStartDate, "MMM DD, YYYY hh:mm A", true).format();
      }

      if (IS_VALID(campaignEndDate)) {
        dataToAppend.campaignEndDate = moment(campaignEndDate, "MMM DD, YYYY hh:mm A", true).format();
      }

      if (IS_VALID(image)) {
        if (IS_VALID(image.isOld) && image.isOld) {
          dataToAppend.isImageChange = false;
        } else {
          dataToAppend.image = image;
        }
      }

      if (IS_VALID(bannerImage)) {
        if (IS_VALID(bannerImage.isOld) && bannerImage.isOld) {
          dataToAppend.isBannerImageChange = false;
        } else {
          dataToAppend.bannerImage = bannerImage;
        }
      }

      for (let key in dataToAppend) {
        fd.append([key], dataToAppend[key]);
      }

      let httpMethod = "post",
          url = `${WEB_PATH}/CampaignCategory`;

      if ((!IS_EMPTY_STRING(formType) && formType.toUpperCase() === "UPDATE") && !IS_EMPTY_STRING(formId)) {
        httpMethod = "put";
        url = `${url}/${formId}`;
      }

      actions.setValue({ isLoadingAction: true });

      axios[httpMethod](url, fd)
      .then((res) => {
        actions.setValue({
          isLoadingAction: false,
          showModal: false
        });

        this.refreshTable();
      })
      .catch((err) => {
        actions.setValue({
          isLoadingAction: false,
          showModal: false
        });

        this.refreshTable();
      });
    }
  }

  deleteData () {
    let {
      CampaignCategory,
      actions
    } = this.props;
    
    let {
      selectedData
    } = CampaignCategory;

    if (IS_VALID(selectedData)) {
      actions.setValue({ isLoadingAction: true });

      selectedData.set("isDeleted", true);

      selectedData.save()
      .then((data) => {
        actions.setValue({
            isLoadingAction: false,
            showModal: false
        });

        this.refreshTable();
      })
      .catch((err) => {
        actions.setValue({
            isLoadingAction: false,
            showModal: false
        });

        this.refreshTable();
      });
    }
  }

  refreshTable () {
    if (IS_VALID(this.refreshTableReference) && typeof this.refreshTableReference === 'function') {
      this.refreshTableReference();
    }
  }

  loadOptions (input, cb, className, columnName, sortColumn = columnName) {
    let query,
        objectItem = (item) => {
          let json = {
            label: item.get(columnName),
            value: item.id
          };

          return json;
        };

    query = new Parse.Query(className);

    query.matches(columnName, input, 'i');
    query.ascending(sortColumn);

    query.limit(20);

    query.find()
    .then((data) => {
			return data.map(objectItem);
		}).then((data) => {
			cb(null, {options: data});
		})
    .catch((err) => {
      console.log('Load Select Options error: ', err.message);
      cb(null, {options: []});
    })
  }

  renderModalButton () {
    let {
      CampaignCategory,
      actions
    } = this.props;

    let {
      isLoadingAction,
      formType,
      selectedData
    } = CampaignCategory;

    let status = IS_VALID(selectedData) ? selectedData.get("status") : "";

    let buttons = [],
        buttonAction = (title = "CREATE", action = this.saveData, props = { bsStyle: "primary" }) => (
          <Button
            {...props}
            disabled={isLoadingAction}
            onClick={() => action()}
          >
            {title}
          </Button>
        ),
        buttonClose = (
          <Button
            disabled={isLoadingAction}
            onClick={() => {
              if (!isLoadingAction) {
                actions.setValue({ showModal: false });
              }
            }}
          >
            CLOSE
          </Button>
        );

    switch (formType.toUpperCase()) {
      case "CREATE":
        buttons.push(
          buttonAction("PUBLISH"),
          buttonAction("SAVE AS DRAFT", () => this.saveData(true), {}),
          buttonClose
        );
        break;
      case "UPDATE":
        buttons.push(buttonAction(status === "PUBLISH" || status === "EXPIRED" ? "UPDATE": "PUBLISH"));

        if (
          status !== "PUBLISH" &&
          status !== "EXPIRED"
        ) {
          buttons.push(buttonAction("SAVE AS DRAFT", () => this.saveData(true), {}));
        }

        buttons.push(buttonClose);
        break;
      case "DELETE":
        buttons.push(
          buttonAction("DELETE", this.deleteData),
          buttonClose
        );
        break;
      default:
          buttons.push(
            buttonClose
          );
        break;
    }

    return buttons;
  }

  render () {
    let {
      accessjson,
      CampaignCategory,
      actions
    } = this.props;

    let {
      showModal,
      isLoadingAction,
      formType,
      formTitle,
      evoucherSortColumnOptions,
      evoucherSortingOptions
    } = CampaignCategory;

    let crudProps = {
      schema: CampaignCategorySchema,
      moduleQuery: [
        { method: "descending", column: "createdAt" }
      ],
      access: accessjson.access,
      refreshTable: (refreshTable) => {
        this.refreshTableReference = refreshTable;
      },
      customView: (obj) => {
        actions.setValue({
            showModal: true,
            formType: "VIEW",
            formTitle: "VIEW CAMPAIGN CATEGORY",
            formId: obj.id,
            selectedData: obj
        });
      },
      customCreate: () => {
        actions.setValue({
          showModal: true,
          formType: "CREATE",
          formTitle: "CREATE CAMPAIGN CATEGORY"
        });
      },
      customUpdate: (obj) => {
        let stateToUpdate = {
          showModal: true,
          formType: "UPDATE",
          formTitle: "UPDATE CAMPAIGN CATEGORY",
          formId: obj.id,
          selectedData: obj
        };

        if (IS_VALID(obj.get("title"))) {
          stateToUpdate.title = obj.get("title");
        }

        if (IS_VALID(obj.get("descriptions"))) {
          stateToUpdate.descriptions = obj.get("descriptions");
        }

        if (IS_VALID(obj.get("earningPeriod"))) {
          stateToUpdate.earningPeriod = {
            label: obj.get("earningPeriod").get("name"),
            value: obj.get("earningPeriod").id
          };
        }

        if (IS_VALID(obj.get("earningPeriodStartDate"))) {
          stateToUpdate.earningPeriodStartDate = moment(obj.get("earningPeriodStartDate"));
        }

        if (IS_VALID(obj.get("earningPeriodEndDate"))) {
          stateToUpdate.earningPeriodEndDate = moment(obj.get("earningPeriodEndDate"));
        }

        if (IS_VALID(obj.get("campaignStartDate"))) {
          stateToUpdate.campaignStartDate = moment(obj.get("campaignStartDate"));
        }

        if (IS_VALID(obj.get("campaignEndDate"))) {
          stateToUpdate.campaignEndDate = moment(obj.get("campaignEndDate"));
        }

        if (IS_VALID(obj.get("image"))) {
          stateToUpdate.image = { preview: obj.get("image").url(), isOld: true };
        }

        if (IS_VALID(obj.get("bannerImage"))) {
          stateToUpdate.bannerImage = { preview: obj.get("bannerImage").url(), isOld: true };
        }

        if (IS_VALID(obj.get("availabilityTimeConfig"))) {
          let timeConfig = obj.get("availabilityTimeConfig");

          let month = moment().month(),
            date = moment().date(),
            year = moment().year();

          if (IS_VALID(timeConfig.start)) {
            stateToUpdate.availabilityStartTime = moment(timeConfig.start, "hh:mm A", true).month(month).date(date).year(year);
          }

          if (IS_VALID(timeConfig.end)) {
            stateToUpdate.availabilityEndTime = moment(timeConfig.end, "hh:mm A", true).month(month).date(date).year(year);
          }
        }

        if (IS_VALID(obj.get("evoucherSortColumn"))) {
          for (let item of evoucherSortColumnOptions) {
            if (
              item.value === obj.get("evoucherSortColumn")
            ) {
              stateToUpdate.evoucherSortColumn = item;
              break;
            }
          }
        }
        
        if (IS_VALID(obj.get("evoucherSorting"))) {
          for (let item of evoucherSortingOptions) {
            if (
              item.value === obj.get("evoucherSorting")
            ) {
              stateToUpdate.evoucherSorting = item;
              break;
            }
          }
        }

        actions.setValue(stateToUpdate);
      },
      customDelete: (obj) => {
        actions.setValue({
            showModal: true,
            formType: "DELETE",
            formTitle: "DELETE CAMPAIGN CATEGORY",
            formId: obj.id,
            selectedData: obj
        });
      },
      customItems: [
        {
          columnName: "title",
          render: ({value, column, getTableData, object}) => {
            let renderValue = "";

            if (IS_VALID(value)) {
              renderValue = value.substr(0, 100).trim() + (value.length <= 100 ? "" : "...");
            }

            return renderValue;
          }
        },
        {
          columnName: "descriptions",
          render: ({value, column, getTableData, object}) => {
            let renderValue = "";

            if (IS_VALID(value)) {
              renderValue = value.substr(0, 100).trim() + (value.length <= 100 ? "" : "...");
            }

            return renderValue;
          }
        },
        {
          columnName: "status",
          render: ({value, column, getTableData, object}) => {
            let renderValue = value;

            if (IS_VALID(value)) {
              switch (value.toUpperCase()) {
                case "PUBLISH":
                  renderValue = <span style={{ color: "green" }}>{value}</span>;
                  break;
                case "EXPIRED":
                  renderValue = <span style={{ color: "red" }}>{value}</span>
                  break;
                case "DRAFT":
                  renderValue = <span style={{ color: "gray" }}>{value}</span>
                  break;
              }
            }

            return renderValue;
          }
        }
      ]
    };
    
    let formContainerProps = {
      loadOptions: this.loadOptions
    };

    return (
        <div>
          <Panel>
            <Panel.Heading
              style={{
                backgroundColor: '#D1282F',
                color: 'white'
              }}
            >
              <h4>Campaign Category</h4>
            </Panel.Heading>
            <Panel.Body>
              <CrudComponent {...crudProps}/>
            </Panel.Body>
          </Panel>
          <Modal
            bsSize={formType.toUpperCase() === "DELETE"  ? null : "large"}
            backdrop="static"
            show={showModal}
            onHide={() => {
              if (!isLoadingAction) {
                actions.setValue({ showModal: false });
              }
            }}
          >
            <Modal.Header closeButton>
              <Modal.Title>{formTitle.toUpperCase()}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <FormContainer {...formContainerProps}/>
            </Modal.Body>
            <Modal.Footer>
              {this.renderModalButton()}
            </Modal.Footer>
          </Modal>
          <ToastContainer />
        </div>
    );
  }
}

import {connect}            from 'react-redux';
import {bindActionCreators} from 'redux';
import {generics}           from 'actions';
import {
  CAMPAIGN_CATEGORY
}                           from "actions/const";

function mapStateToProps(state) {
	let {
    accessjson,
    CampaignCategory
	} = state;

	return {
    accessjson,
    CampaignCategory
	};
}

function mapDispatchToProps(dispatch) {
  const actions = {
    setValue: (state, action = CAMPAIGN_CATEGORY) => generics.setValue(action, state)
  };

  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CampaignCategory);


// WEBPACK FOOTER //
// ./components/CampaignCategory/index.js